module.exports = __webpack_public_path__ + "static/media/tips1.b903b4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/tips1.png
// module id = 421
// module chunks = 0